export default {"src":"/_next/static/media/playbutton.940a7f69.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};